import {CompositeAccessRule, defineAccessControlledResource, GroupAccessRule} from '@igp/shared/access-control';

import {DebtResponsibleMasterAgentAccessRule, groups} from '@access-control';

export const repaymentLogsPageResource = defineAccessControlledResource({
    name: 'RepaymentLogsPageResource',
    rules: new CompositeAccessRule([new GroupAccessRule([groups.adminsGroup]), new DebtResponsibleMasterAgentAccessRule()], 'or'),
});

export const editRepaymentLogsResource = defineAccessControlledResource({
    name: 'editRepaymentLogsResource',
    rules: new GroupAccessRule([groups.adminsGroup]),
});
